import React, { useState, useEffect } from 'react'
import CustomSlider from '../../components/elements/Slider'
import CustomTextField from '../../components/elements/TextField'
import { 
    calculatePricePerDocument, 
    calculateUpgradePrices, 
    extractPricePoints, 
    extractUpgradePricePoints 
} from '../../util/priceCalculation'

type Props = {
    tariffs: any[]
    onQuantityChange?: (quantity: number) => void
}

function CustomQuantitySlider({ tariffs, onQuantityChange }: Props) {
    const [quantity, setQuantity] = useState(100)
    const [price, setPrice] = useState(0)
    const [pricePerDocument, setPricePerDocument] = useState(0)

    // Находим минимальный и максимальный размеры из всех тарифов
    const allPackageSizes = tariffs.map(tariff => tariff.prepaid_documents_count || 0)
    const sortedSizes = allPackageSizes.sort((a, b) => a - b)
    
    // Минимальный размер - первый пакет
    const minSize = sortedSizes.length > 0 ? sortedSizes[0] : 10
    // Максимальный размер - последний пакет умноженный на 5
    const maxSize = sortedSizes.length > 0 ? sortedSizes[sortedSizes.length - 1] * 2 : 20000

    // Округляем до ближайших 10
    const minQuantity = Math.ceil(minSize / 10) * 10
    const maxQuantity = Math.ceil(maxSize / 10) * 10

    console.log('minQuantity', minQuantity)
    console.log('maxQuantity', maxQuantity)
    // Единая функция для обновления количества
    function updateQuantity(newQuantity: number) {
        const roundedValue = Math.round(newQuantity / 10) * 10
        const clampedValue = Math.max(minQuantity, Math.min(maxQuantity, roundedValue))
        
        setQuantity(clampedValue)
        calculatePrice(clampedValue)
    }

    function calculatePrice(qty: number) {
        // Извлекаем контрольные точки цен из тарифов
        const pricePoints = extractPricePoints(tariffs)
        
        // Рассчитываем цену за документ
        const pricePerDoc = calculatePricePerDocument(qty, pricePoints)
        
        setPrice(qty * pricePerDoc)
        setPricePerDocument(pricePerDoc)
        
        // Уведомляем родительский компонент только о количестве
        if (onQuantityChange) {
            onQuantityChange(qty)
        }
    }

    function handleSliderChange(event: Event, newValue: number | number[]) {
        const value = Array.isArray(newValue) ? newValue[0] : newValue
        updateQuantity(value)
    }

    function handleInputChange(event: React.ChangeEvent<HTMLInputElement>) {
        // Убираем форматирование (пробелы и запятые) и парсим число
        const rawValue = event.target.value.replace(/[\s,]/g, '')
        const value = parseInt(rawValue) || 0
        
        // Обновляем состояние без ограничений - пользователь может вводить что угодно
        setQuantity(value)
        
        // Рассчитываем цену для введенного значения (с ограничениями для корректного расчета)
        const clampedValueForPrice = Math.max(minQuantity, Math.min(maxQuantity, value))
        calculatePrice(clampedValueForPrice)
        
        console.log('handleInputChange', { value, rawValue, originalValue: event.target.value })
    }

    function handleInputBlur() {
        // При потере фокуса применяем ограничения
        const clampedValue = Math.max(minQuantity, Math.min(maxQuantity, quantity))
        
        setQuantity(clampedValue)
        calculatePrice(clampedValue)
        
        console.log('handleInputBlur', { quantity, clampedValue, minQuantity, maxQuantity })
    }


    return (
        <div className="custom-quantity-v2">
            <div className="slider-input-row">
                <div className="slider-container">
                    <CustomSlider
                        value={quantity}
                        min={minQuantity}
                        max={maxQuantity}
                        step={10}
                        onChange={handleSliderChange}
                        valueLabelDisplay="off"
                    />
                    <div className="slider-labels">
                        <span className="min-label">{minQuantity.toLocaleString()}</span>
                        <span className="current-value">{quantity.toLocaleString()}</span>
                        <span className="max-label">{maxQuantity.toLocaleString()}</span>
                    </div>
                </div>

                <div className="quantity-input">
                    <CustomTextField
                        value={quantity.toLocaleString()}
                        onChange={handleInputChange}
                        onBlur={handleInputBlur}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                width: 80,
                            },
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default CustomQuantitySlider